import React, { Component, Fragment } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import api from "../../services/api";
import './API.css';

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const ApiList =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				orgaosFornecedores: [],
				orgaoFornecedor: '',
				orgaosOperadores: [],
				orgaoOperador: '',
				fornecedoras: [],
				fornecedora: '',
				disponivelAdesaoOrgao: '',
				fornecedorAutorizaInclusaoAdesao: '',
				fornecedorAutorizaAlteracaoAdesao: '',
				carregandoOrgaosFornecedores: false,
				carregandoOrgaosOperadores: true,
				carregandoFornecedoras: false,
				resultadoPesquisa: {},
				pesquisaExecutada : false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				esferaAdministrativa: '',
			};
			
			this.state = this.initialState;
			
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoFornecedorChange = this.handleOrgaoFornecedorChange.bind(this);
			this.handleOrgaoOperadorChange = this.handleOrgaoOperadorChange.bind(this);
			this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
			this.carregaFornecedoras = this.carregaFornecedoras.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>API's</h1>
					</div>
					<div className="div-form1">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			this.setState(
				{
					carregandoOrgaosFornecedores: true,
					carregandoFornecedoras: true
				}
			);

			api.get('/api/orgao/fornecedores')
			.then(response => { 
				this.setState(
					{
						orgaosFornecedores: response.data,
						carregandoOrgaosFornecedores: false
					}
				) 
			})
			.catch(erro => {
				this.setState({carregandoOrgaosFornecedores : false});
				console.log("Não foi possível recuperar órgãos fornecedores" + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			api.get('/api/orgao/operadores')
			.then(response => { 
				this.setState(
					{
						orgaosOperadores: response.data,
						carregandoOrgaosOperadores: false
					}
				) 
			})
			.catch(erro => {
				this.setState({carregandoOrgaosOperadores : false});
				console.log("Não foi possível recuperar órgãos operadores" + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			this.carregaFornecedoras('', '', '');

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const numberFormater = new Intl.NumberFormat('pt-BR', {useGrouping: true });

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="orgaoFornecedor">Órgao Fornecedor:</label>
										{ this.state.orgaosFornecedores.length > 0 && 
											<SelectSearch
												id="orgaoFornecedor"
												name="orgaoFornecedor"
												options={this.state.orgaosFornecedores.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
												includeAllOption={true}
												onChange={this.handleOrgaoFornecedorChange}
												value={this.state.orgaoFornecedor}
											/>
										}
										{this.state.carregandoPlanos === false && this.state.orgaosFornecedores.length === 0 && 'Não há órgãos fornecedores de API'}
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="orgaoOperador">Órgao Operador de Dados:</label>
										{ this.state.orgaosOperadores.length > 0 && 
										<SelectSearch
											id="orgaoOperador"
											name="orgaoOperador"
											options={this.state.orgaosOperadores.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
											includeAllOption={true}
											onChange={this.handleOrgaoOperadorChange}
											value={this.state.orgaoOperador}
										/>
										}
										{this.state.carregandoPlanos === false && this.state.orgaosOperadores.length === 0 && 'Não há órgãos operadores de Dados'}
									</div>
								</div>
							</div>
						</div>	

						<div className="row">
							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label>Esfera Administrativa:</label>
										<SelectSearch
											id="esferaAdministrativa"
											name="esferaAdministrativa"
											allOptionName="Todas"
											options={this.state.esferasAdministrativas.map(esfera => ({ value: esfera.codigo, label: esfera.nome }))}
											includeAllOption={true}
											onChange={this.handleEsferaAdministrativaChange}
											value={this.state.esferaAdministrativa}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{ this.state.fornecedoras.length > 0 && 
											<SelectSearch
												id="fornecedora"
												allOptionName="Todas"
												name="fornecedora"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={this.state.fornecedora}
											/>
										}
										{this.state.carregandoFornecedoras === false && this.state.fornecedoras.length === 0 && 'Não foram encontradas APIs com os critérios informados.'}
									</div>
								</div>
							</div>
						</div>
				
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="disponivelAdesaoOrgao">Disponível para adesão dos órgãos:</label>
										<SelectSearch
											id="disponivelAdesaoOrgao"
											name="disponivelAdesaoOrgao"
											options={[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={this.state.disponivelAdesaoOrgao}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="fornecedorAutorizaInclusaoAdesao">Adesão exige aprovação do órgão cedente dos dados:</label>
										<SelectSearch
											id="fornecedorAutorizaInclusaoAdesao"
											name="fornecedorAutorizaInclusaoAdesao"
											options={[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={this.state.fornecedorAutorizaInclusaoAdesao}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="fornecedorAutorizaAlteracaoAdesao">Alteração de volumetria exige aprovação do órgão cedente dos dados:</label>
										<SelectSearch
											id="fornecedorAutorizaAlteracaoAdesao"
											name="fornecedorAutorizaAlteracaoAdesao"
											options={[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={this.state.fornecedorAutorizaAlteracaoAdesao}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()}>Limpar</button>
								<ButtonBack />
							</div>
						</div>

						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">API</th>
											<th scope="col">Órgão Fornecedor</th>
											<th scope="col">Órgão Operador de Dados</th>

											<th scope="col" style={{width: "5%"}}>Esferas</th>
											<th scope="col" className="text-center" style={{width: "5%"}}>Disponível para Adesão</th>
											<th scope="col" className="text-center" style={{width: "5%"}}>Adesão exige aprovação do órgão cedente</th>
											<th scope="col" className="text-center" style={{width: "5%"}}>Alteração volumetria exige aprovação do órgão cedente</th>

											<th scope="col" className="text-right">Limite Consultas/Ano</th>
											<th scope="col" className="text-right">Total Consumido no Ano</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((fornecedora, index) =>
													<tr key={index} >
														<td>{fornecedora.nome}</td>
														<td>{fornecedora.orgao}</td>
														<td>{fornecedora.orgaoOperador ? fornecedora.orgaoOperador : ''}</td>

														<td>{fornecedora.esferasAdministrativas.map(esfera => <Fragment>{esfera.nome}<br/></Fragment>)}</td>

														<td className="text-center">{fornecedora.disponivelAdesaoOrgao ? 'Sim' : 'Não'}</td>
														<td className="text-center">{fornecedora.fornecedorAutorizaInclusaoAdesao ? 'Sim' : 'Não'}</td>
														<td className="text-center">{fornecedora.fornecedorAutorizaAlteracaoAdesao ? 'Sim' : 'Não'}</td>
														{fornecedora.limiteConsultaAnual !== null &&
															<td className="text-right">{numberFormater.format(fornecedora.limiteConsultaAnual)}</td>
														}
														{fornecedora.limiteConsultaAnual === null &&
															<td>&nbsp;</td>
														}
														<td className="text-right">{numberFormater.format(fornecedora.consumoAnoCorrente)}</td>

														<td className="text-center">
															<div className="actions">
																<Link to={`/api/edit/${fornecedora.id}`}>
																	<button type="button" title="Editar as informações da API">
																		<span className="sr-only">Editar</span>
																		<i className="fas fa-edit"></i>
																	</button>
																</Link>
																<Link to={`/api/attachments/${fornecedora.id}`}>
																	<button type="button" title="Editar anexos da API">
																		<span className="sr-only">Anexos</span>
																		<i class="fas fa-paperclip"></i>
																	</button>
																</Link>					
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma API encontrada com os critérios informados.
							</div>
						}

					</div>
				</div>

				
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		handleOrgaoFornecedorChange(evento){
			const orgaoFornecedor =  evento.target.value;
			this.setState({orgaoFornecedor});
			this.carregaFornecedoras(orgaoFornecedor, this.state.orgaoOperador, this.state.esferaAdministrativa);
		}

		handleOrgaoOperadorChange(evento){
			const orgaoOperador =  evento.target.value;
			this.setState({orgaoOperador});
			this.carregaFornecedoras(this.state.orgaoFornecedor, orgaoOperador, this.state.esferaAdministrativa);
		}

		handleEsferaAdministrativaChange(evento){
			const esferaAdministrativa =  evento.target.value;
			this.setState({esferaAdministrativa});
			this.carregaFornecedoras(this.state.orgaoFornecedor, this.state.orgaoOperador, esferaAdministrativa);
		}

		carregaFornecedoras(fornecedor, operador, esfera){
			this.setState({carregandoFornecedoras: true});
			this.props.mostraAguardando();
			api.get(`/api/aplicacao-fornecedora/orgao-fornecedor-operador?idOrgaoFornecedor=${fornecedor}&idOrgaoOperador=${operador}&codigoEsferaAdministrativa=${esfera}`)
			.then(response => { 
				this.setState(
					{
						fornecedoras: response.data,
						fornecedora: '',
						carregandoFornecedoras: false,
					}
				);
				this.props.escondeAguardando();
			})
			.catch(erro => {
				this.props.escondeAguardando();
				this.setState({carregandoFornecedoras: false});
				console.log("Não foi possível recuperar as aplicações fornecedoras: " + JSON.stringify(erro));
				this.props.exibeMensagemErro("Erro durante o carregamento das API's do órgão.")
			});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];
			
			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada(pagina){

			const {orgaoFornecedor, orgaoOperador, fornecedora, esferaAdministrativa, disponivelAdesaoOrgao, fornecedorAutorizaInclusaoAdesao, fornecedorAutorizaAlteracaoAdesao } = this.state;
			const criterioPesquisa = {orgaoFornecedor, orgaoOperador, fornecedora, esferaAdministrativa, disponivelAdesaoOrgao, fornecedorAutorizaInclusaoAdesao, fornecedorAutorizaAlteracaoAdesao, pagina};
			const url = '/api/aplicacao-fornecedora/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando()
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as API's. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then( () => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			this.setState({
				orgaoFornecedor: '',
				orgaoOperador: '',
				fornecedora: '',
				disponivelAdesaoOrgao: '',
				fornecedorAutorizaInclusaoAdesao: '', 
				fornecedorAutorizaAlteracaoAdesao: '',
				esferaAdministrativa: '',
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			}, () => {
				this.carregaFornecedoras('', '', '');
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}
		
	}

) // redux
); // router